import React from 'react';

import BlueButton from '../../buttons/BlueButton';
import Back from './backstep';
import Permision from './permission';

class Permissions extends React.Component {

    state = {
        current: 0
    }

    handleOnNext = event => {


        const { onboarding_permission, onboarding } = this.props;
        const id = onboarding.permisos.length;

        const completed = onboarding.permisos.reduce((result, p, index) => { 
            const info = onboarding_permission.find((o) => o.id === p.id)
            if( id >= index 
                && result + 1 === index 
                && ( !info.requerido  || (p.roles && p.roles.length > 0 ))) {
                result = index;
            } 
            return result;
        }, 0)

        if( completed + 1 < id ){
            this.setCurrent( completed + 1 );
        } else {
            this.props.onNext();
        }
    }

    setCurrent = id => {

        const { onboarding_permission, onboarding } = this.props;
        const completed = onboarding.permisos.reduce((result, p, index) => { 
            const info = onboarding_permission.find((o) => o.id === p.id)
            if( id >= index 
                && result + 1 === index 
                && ( !info.requerido  || (p.roles && p.roles.length > 0 ))) {
                result = index;
            } 
            return result;
        }, 0)
        this.setState({ current: id > completed ? completed + 1 : completed });

    }

    handleCheck = (id, rol) => {
        let { onboarding } = this.props;
        if(!onboarding.permisos) {
            onboarding.permisos = [];
        }
        if(onboarding.permisos.length < id + 1) {
            onboarding.permisos.push(
                {
                    "id": id,
                    "roles": []
                }
            )
        }
        const roles = [...onboarding.permisos[id].roles];
        const index = roles.indexOf(rol);
        if(index >= 0) {
            roles.splice(index, 1);
        } else {
            roles.push(rol);
        }
        onboarding.permisos[id].roles = roles;
        this.props.onSave('permisos', onboarding.permisos);
    }

    render() {
        const { onboarding_permission, onboarding } = this.props;
        const { current } = this.state;
        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    <div className="ob_welcome text_align_left_important">
                        {(onboarding_permission && onboarding_permission.length > 0) &&
                            onboarding_permission.map((p, index) => <Permision 
                                                                        key={'permisos-' + current + "-" + index} 
                                                                        id={index} 
                                                                        current={current}
                                                                        info={p} 
                                                                        allroles={onboarding.roles} 
                                                                        permiso={onboarding.permisos && onboarding.permisos.find((o) => o.id ===  p.id) 
                                                                                    ? onboarding.permisos.find((o) => o.id ===  p.id)
                                                                                    : undefined
                                                                                }
                                                                        onClick={this.setCurrent}
                                                                        onCheck={this.handleCheck}
                                                                    />)
                        }
                    </div>
                </div>
                <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                    <BlueButton 
                        id="next" 
                        className="ob_next" 
                        onClick={this.handleOnNext} 
                    />
                </div>
            </div>

        );
    }
}

export default Permissions;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/permissions.js